import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/home/Home";
import Dashboard from "@/views/dashboard/Dashboard";
import PostalBoxes from "@/views/dashboard/boxes/PostalBoxes";
import FAQs from "@/views/home/FAQs";
import ContactUs from "@/views/home/ContactUs";
import Mail from "@/views/dashboard/mail/Mail";
import Services from "@/views/dashboard/services/Services";
import Transactions from "@/views/dashboard/transactions/Transactions";
import Delivery from "@/views/dashboard/delivery/Delivery";
import Tracking from "@/views/home/Tracking";
import TrackingInternal from "../views/dashboard/tracking/TrackingInternal";
import EpostaServices from "../views/home/EpostaServices";
import BoxRenewal from "@/views/dashboard/box-renewal/BoxRenewal";
import RenewBox from "@/views/home/RenewBox";
import PayArrears from "@/views/dashboard/pay-arrears/PayArrears";
import ApplyBox from "@/views/dashboard/apply-box/ApplyBox";
import Account from "@/views/dashboard/Account";

Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect:
        localStorage.getItem("eposta_account") === null
          ? "/home"
          : "/dashboard",
    },

    {
      path: "/dashboard",
      component: Dashboard,
      name: "user_dashboard",
      redirect: "/dashboard/boxes",
      meta: {
        requiresAuth: true,
      },
      children: [
        { path: "boxes", component: PostalBoxes },
        {
          path: "mail",
          component: Mail,
          meta: {
            title: "Mails | Dashboard",
          },
        },
        {
          path: "delivery",
          component: Delivery,
          meta: {
            title: "Delivery | Dashboard",
          },
        },
        {
          path: "services",
          component: Services,
          meta: {
            title: "Services | Dashboard",
          },
        },
        { path: "transactions", component: Transactions },
        {
          path: "tracking",
          component: TrackingInternal,
          meta: {
            title: "Mails | Dashboard",
          },
        },
        { path: "box-renewal", component: BoxRenewal },
        {
          path: "pay-arrears",
          component: PayArrears,
          meta: {
            title: "Arrears | Dashboard",
          },
        },
        { path: "apply-box", component: ApplyBox },
      ],
    },
    {
      path: "/",
      component: Account,
      redirect: "/",
      children: [
        {
          path: "home",
          component: Home,
          name: "homePage",
          meta: {
            title: "Home Eposta ",
          },
          metaTags: [
            {
              name: "description",
              content: "The home page for Eposta",
            },
            {
              property: "og:description",
              content: "The home page for Eposta",
            },
          ],
        },
        { path: "track", component: Tracking },
        { path: "box-renewal", component: RenewBox },
        { path: "faqs", component: FAQs },
        { path: "contact", component: ContactUs },
        { path: "services", component: EpostaServices },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("eposta_account") == null) {
      next({
        name: "homePage",
        params: { nextUrl: to.fullPath },
      });
    } else {
      let user = JSON.parse(localStorage.getItem("eposta_account"));
      if (user !== null) {
        next();
      } else {
        next({ name: "user_dashboard" });
      }
    }
  } else {
    if (localStorage.getItem("eposta_account") === null) {
      next();
    } else {
      next({
        name: "user_dashboard",
      });
    }
  }
});

const DEFAULT_TITLE = "Dashboard | Eposta ";
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
  console.log(from);
});

export default router;
